import StoreRootHelpers from '@monolith/legacy/store/helpers';
import CartHelpers from '@monolith/legacy/store/cart/helpers';

/**
 * Single entry point for all cart and user Vuex state needed by add-to-cart.
 * Prevents scattered CartHelpers / StoreRootHelpers calls across composables.
 */
export function useCartStore() {
  const { user, userCurrency, userIsRetailer, userIsBrand, canGetWholesalePrice } =
    StoreRootHelpers.useGetters(['user', 'userCurrency', 'userIsRetailer', 'userIsBrand', 'canGetWholesalePrice']);

  const { itemByOptionId, itemByVariantId } =
    CartHelpers.useGetters(['itemByOptionId', 'itemByVariantId']);

  const { addToCart, updateItemQuantity, deleteItem } =
    CartHelpers.useActions(['addToCart', 'updateItemQuantity', 'deleteItem']);

  return {
    user,
    userCurrency,
    userIsRetailer,
    userIsBrand,
    canGetWholesalePrice,
    itemByOptionId,
    itemByVariantId,
    addToCart,
    updateItemQuantity,
    deleteItem,
  };
}
